import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
export const AsyncFormattedPropertyPhone = Loadable({
  loader: () => import('../../input/phone/codesplit/FormattedPropertyPhone').then(module => module.default),
  LoadingComponent: ({
    value
  }) => {
    return /*#__PURE__*/_jsx("span", {
      children: value
    });
  }
});